import React from "react";
import { Tooltip } from "@mui/material";

/**
 * Same disabled + tooltip pattern as CustomHeader on /dashboard/orders.
 * Span shrink-wraps the control so the tooltip sits with consistent spacing above the button.
 */
export default function DisabledTooltipWrap({
  title,
  disabled = false,
  children,
  placement = "top",
}) {
  const wrapped = (
    <span style={{ display: "inline-flex", width: "fit-content" }}>{children}</span>
  );

  if (disabled && title) {
    return (
      <Tooltip title={title} arrow placement={placement}>
        {wrapped}
      </Tooltip>
    );
  }

  return wrapped;
}
